import React from "react";
import ContentLoader from "react-content-loader";

export const HeadingTitleLoader = () => (
  <ContentLoader
    speed={2}
    width={400}
    height={50}
    viewBox="0 0 400 50"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" rx="0" ry="0" width="190" height="38" />
  </ContentLoader>
);
